// Alvna brand design tokens — matches the design system built for
// order.alvna.com (Space Grotesk + Inter, blue→violet gradient, shared
// spacing/radius/type scale) so this trial app reads as the same product.

export const colors = {
  brandBlue: "#4f7cff",
  brandViolet: "#8b5cf6",
  brandGradient: "linear-gradient(120deg, #4f7cff, #8b5cf6)",

  statusNew: "#4f7cff",
  statusProgress: "#d68a1f",
  statusReady: "#1f9d6e",
  statusNeutral: "#8a91a8",

  textPrimary: "#1a1d29",
  textSecondary: "#6b7280",
  textMuted: "#9ca3af",
  border: "#e5e7eb",
  surface: "#ffffff",
  surfaceMuted: "#f7f8fa",
  bgPage: "#eef1f7",

  // Dark theme, for staff/floor screens (waiter, kitchen)
  darkBg: "#12131a",
  darkSurface: "#1c1e29",
  darkBorder: "#2c2f3d",
  darkText: "#e8e9ee",
};

export const fonts = {
  display: "'Space Grotesk', sans-serif",
  body: "'Inter', 'Helvetica Neue', Arial, sans-serif",
};

export const type = {
  xs: "12px",
  sm: "13.5px",
  base: "15px",
  md: "17px",
  lg: "20px",
  xl: "25px",
  xxl: "31px",
};

export const space = {
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "24px",
  6: "32px",
  7: "48px",
};

export const radius = {
  sm: "8px",
  md: "14px",
  lg: "22px",
  pill: "999px",
};

// Reusable style fragments
export const buttonPrimary = {
  padding: `${space[3]} ${space[5]}`,
  borderRadius: radius.sm,
  border: "none",
  background: colors.brandGradient,
  color: "#fff",
  fontWeight: 600,
  fontFamily: fonts.body,
  fontSize: type.base,
  cursor: "pointer",
  boxShadow: "0 1px 2px rgba(79,124,255,0.25)",
};

export const buttonSecondary = {
  padding: `${space[3]} ${space[4]}`,
  borderRadius: radius.sm,
  border: `1px solid ${colors.border}`,
  background: colors.surfaceMuted,
  color: colors.textPrimary,
  fontFamily: fonts.body,
  fontSize: type.sm,
  fontWeight: 500,
  cursor: "pointer",
};

export const inputBase = {
  padding: `${space[3]} ${space[3]}`,
  borderRadius: radius.sm,
  border: `1px solid ${colors.border}`,
  fontFamily: fonts.body,
  fontSize: type.base,
};

export const card = {
  background: colors.surface,
  border: `1px solid ${colors.border}`,
  borderRadius: radius.md,
  padding: space[5],
  boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
};

export const pageHeading = {
  fontFamily: fonts.display,
  fontSize: type.xxl,
  fontWeight: 600,
  color: colors.textPrimary,
  margin: 0,
};
